import { render, staticRenderFns } from "./ManagementTableBase.vue?vue&type=template&id=36b6be67&scoped=true"
import script from "./ManagementTableBase.vue?vue&type=script&lang=js"
export * from "./ManagementTableBase.vue?vue&type=script&lang=js"
import style0 from "./ManagementTableBase.vue?vue&type=style&index=0&id=36b6be67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6be67",
  null
  
)

export default component.exports